// © Microsoft Corporation. All rights reserved.
import React, { useEffect } from 'react';
import { Stack, Toggle, Image, ImageFit } from '@fluentui/react';
import { MicIcon, CallVideoIcon } from '@fluentui/react-icons-northstar';
import { Constants } from '../core/constants';
import {
    VideoStreamRendererView,
    VideoDeviceInfo,
    AudioDeviceInfo,
    LocalVideoStream,
    VideoStreamRenderer,
    LocalAudioStream
} from '@azure/communication-calling';
import staticMediaSVG from '../assets/staticmedia.svg';
import {
    toggleStyle,
    imgStyles,
    toggleButtonsBarToken,
    localPreviewContainerStyle,
    toggleButtonsBarStyle,
    localPreviewStyle
} from './styles/LocalPreview.styles';
import { UpdateInterviewActivityLog } from "Utils/participantInfo";

export interface LocalPreviewProps {
    setMic(mic: boolean): void;
    mic: boolean;
    setLocalVideoStream(device: LocalVideoStream | undefined): void;
    setLocalAudioStream(device: LocalAudioStream | undefined): void;
    videoDeviceInfo: VideoDeviceInfo;
    audioDeviceInfo: AudioDeviceInfo;
    videoDeviceList: VideoDeviceInfo[];
    audioDeviceList: AudioDeviceInfo[];
    localVideoStream: LocalVideoStream;
    localAudioStream: LocalAudioStream;

}

let rendererView: VideoStreamRendererView;

export default (props: LocalPreviewProps): JSX.Element => {
    const imageProps = {
        src: staticMediaSVG.toString(),
        imageFit: ImageFit.cover,
        maximizeFrame: true
    };

    const handleLocalVideoOnOff = (_ev: React.MouseEvent<HTMLElement>, checked = false): void => {

        /*checked = window.isCameraOn == "none" && checked == false? true: checked;*/
        //alert("window.isCameraOn : " + window.isCameraOn + ", checked : " + checked);
        if (window.isCameraOn == "none" && checked == false) {
            checked = true;
            props.setLocalVideoStream(undefined);
        }

        const stream = new LocalVideoStream(window.vdInfo == null ? props.videoDeviceInfo : window.vdInfo);
        //console.log("#COGBEE# :: handleLocalVideoOnOff");
        //console.log(props.videoDeviceInfo)
        window.isCameraOn = checked ? "true" : "false";

        //alert(" changed window.isCameraOn : " + window.isCameraOn + ", checked : " + checked);
        console.log("COGBEE :: props.videoDeviceInfo");
        console.log(props.videoDeviceInfo);

        props.setLocalVideoStream(checked ? stream : undefined);

        let message = "";
        if (window.isCameraOn == "true") {
            message = "##UserRole# switched on the camera during the interview.";
        } else {
            message = "##UserRole# switched off the camera during the interview.";
        }
        UpdateInterviewActivityLog("Call", message); //#Static

    };
    const handleLocalMicOnOff = (_ev: React.MouseEvent<HTMLElement>, checked = false): void => {
        console.log("COGBEE :: props.mic");
        console.log(props.mic);
        window.isMicOn = checked ? "true" : "false";
        if (window.adInfo && window.adInfo != null && window.adInfo != undefined) {
            const astream = new LocalAudioStream(window.adInfo);
            props.setLocalAudioStream(astream);
        }

        props.setMic(checked);

        let message = "";
        if (window.isMicOn == "true") {
            message = "##UserRole# has their audio turned on during the interview.";
        } else {
            message = "##UserRole# has their audio turned off during the interview.";
        }
        UpdateInterviewActivityLog("Call", message); //#Static
    };
    let _renderer = false;
    useEffect(() => {
        (async (): Promise<void> => {

            // alert("1")
            if (props.localVideoStream) {

                // alert("2")
                const renderer: VideoStreamRenderer = new VideoStreamRenderer(props.localVideoStream);
                rendererView = await renderer.createView({ scalingMode: 'Crop', isMirrored: true });
                _renderer = true;
                const container = document.getElementById(Constants.CONFIGURATION_LOCAL_VIDEO_PREVIEW_ID);

                if (container && container.childElementCount === 0) {
                    container.appendChild(rendererView.target);
                }
            }
        })();

        return (): void => {
            if (rendererView && _renderer) {
                _renderer = false;
                //alert("5");
                rendererView.dispose();
                //delete rendererView;
            }
        };
    }, [props.localVideoStream]);
    return (
        <Stack className={localPreviewContainerStyle}>
            <Stack
                horizontalAlign="center"
                verticalAlign="center"
                id={Constants.CONFIGURATION_LOCAL_VIDEO_PREVIEW_ID}
                className={localPreviewStyle}
            >
                {!props.localVideoStream && <Image styles={imgStyles} {...imageProps} aria-label="Local video preview image" />}
            </Stack>
            <Stack
                horizontal
                horizontalAlign="center"
                verticalAlign="center"
                tokens={toggleButtonsBarToken}
                className={toggleButtonsBarStyle}
            >
                <CallVideoIcon size="medium" />
                <Toggle
                    checked={props.localVideoStream !== undefined}
                    styles={toggleStyle}
                    disabled={!props.videoDeviceInfo || props.videoDeviceList.length === 0}
                    onChange={handleLocalVideoOnOff}
                    id="cameraIconId"
                    ariaLabel="Video Icon"
                />
                <MicIcon size="medium" />
                <Toggle
                    checked={props.mic}
                    styles={toggleStyle}
                    disabled={!props.audioDeviceInfo || props.audioDeviceList.length === 0}
                    onChange={handleLocalMicOnOff}
                    id="micIconId"
                    ariaLabel="Microphone Icon"
                />
            </Stack>
        </Stack>
    );
};
